export default {"src":"/evde-internet/_next/static/media/locationIcon.77e66c72.svg","height":32,"width":32};